import { makeStyles } from '@material-ui/core';
import {  MODAL_BUTTON_VARIANTS } from './constants';

export const useModalStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
  },
  content: {
    margin             : theme.spacing(2, 0),
    display            : 'grid',
    gridTemplateColumns: '1fr',
    gridGap            : theme.spacing(2),
    justifyItems       : 'center',
  },
  actions: {
    display            : 'grid',
    gridGap            : theme.spacing(3),
    gridTemplateColumns: 'repeat(2, auto)',
    justifyContent     : 'space-between',

    '& button': {
      width        : 'fit-content',
      textTransform: 'none',
    },

  },
  iconAlert: {
    color   : theme.palette.warning.main,
    fontSize: '72px',
  },
  [`button-${MODAL_BUTTON_VARIANTS.primary}`]: {
    backgroundColor: theme.palette.primary.main,
  },
  [`button-${MODAL_BUTTON_VARIANTS.secondary}`]: {
    backgroundColor: theme.palette.secondary.main,
  },
  [`button-${MODAL_BUTTON_VARIANTS.warning}`]: {
    backgroundColor: theme.palette.warning.main,
  },
  [`button-${MODAL_BUTTON_VARIANTS.ko}`]: {
    backgroundColor: theme.palette.error.main,
  },
  [`button-${MODAL_BUTTON_VARIANTS.ok}`]: {
    backgroundColor: theme.palette.success.main,
  },
}));
